import axios from 'axios'
import { Message, MessageBox } from 'element-ui'
import store from '../store'
import { getStore, setStore } from '/utils/storage'

// 创建axios实例
const service = axios.create({
  baseURL: process.env.BASE_API, // api的base_url
  // baseURL: '/api',
  timeout: 15000, // 请求超时时间
  // headers: {
  //   "Content-Type": "text/plain"
  // },
  headers: {
    "Content-Type": "application/json"
  },
  withCredentials: true // 允许携带cookie
})


// axios.defaults.headers.post['Content-Type'] = 'application/json';
// service.defaults.headers["Content-Type"] = "application/json"
service.defaults.timeout = 10000;
// service.defaults.baseURL = '/api';

// request拦截器
service.interceptors.request.use(config => {
  let token = getStore("shuogesha_auth_id");
  if (token) {
    config.headers['shuogesha_auth_id'] = token // 让每个请求携带自定义token 请根据实际情况自行修改
  }
  config.headers['Content-Type'] = 'application/json' // 关键所在
  return config
}, error => {
  // Do something with request error
  console.log(error) // for debug
  Promise.reject(error)
})

// respone拦截器
service.interceptors.response.use(
  response => {
    /**
    * code为非200是抛错 可结合自己业务进行修改
    */
    const res = response.data
    if (res.code != '200') {
      if (res.message) {
        Message({
          message: res.message,
          type: 'error',
          duration: 3 * 1000
        })
      }
      // 401:未登录;
      if (res.code === '443' || res.code === '444') {
        MessageBox.confirm('你已被登出，可以取消继续留在该页面，或者重新登录', '确定登出', {
          confirmButtonText: '重新登录',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          setStore("token", '');
          store.dispatch('logout').then(() => {
            setStore('shuogesha_auth_id', '');
            setStore('unifieduser', '');
            // location.href = 'http://localhost:18080/#/login'
            location.reload()// 为了重新实例化vue-router对象 避免bug
          })
        })
      }
      return Promise.reject('error')
    } else {
      return response.data
    }
  },
  error => {
    console.log('err' + error)// for debug
    Message({
      message: error.message,
      type: 'error',
      duration: 3 * 1000
    })
    return Promise.reject(error)
  }
)

export default service



// WEBPACK FOOTER //
// ./src/utils/request.js